import { AuthContextValues, SetupAuth0Token } from './auth-types';
import { useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  createAction,
  useSubscription,
} from '@cobuildlab/react-simple-state';
import {
  OnTokenErrorEvent,
  OnTokenEvent,
} from './auth-events';
import { Context } from './AuthContext';

export const useSetupAuth0Token = (): SetupAuth0Token => {
  const [isLoading, setIsLoading] = useState(true);
  const [isTokenReady, setIsTokenReady] = useState(false);
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();

  useEffect(() => {
    const tokenAction = createAction(
      OnTokenEvent,
      OnTokenErrorEvent,
      async () => {
        const newAccessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: 'https://ihuw.us.auth0.com/api/v2/',
            email: user?.email,
          },
        });
        // eslint-disable-next-line no-underscore-dangle
        return { token: newAccessToken };
      },
    );

    if (isAuthenticated) {
      setIsLoading(true);
      tokenAction();
    }
  }, [getAccessTokenSilently, isAuthenticated, user?.email]);

  useSubscription(OnTokenEvent, () => {
    setIsTokenReady(true);
    setIsLoading(false);
  });

  return { isLoading, isTokenReady };
};


export const useAuth = (): AuthContextValues => {
  const { isAuthenticated, isLoading, user, refetch } =
    useContext(Context);

  return {
    isAuthenticated,
    isLoading,
    user,
    refetch,
  };
};
